// Type-only: App.tsx and ProductLayout import this file eagerly, and a value import from
// schemas/sku would put zod and every schema into the first download of every admin page.
import type { DashboardNotesFilter } from "@funded-here-interface/common/src/schemas/sku";

export const NOTES_PATH = "/pm-dashboard/notes";

/**
 * Older PM dashboard URLs, redirected into the notes table by App.tsx. /activenotes was the
 * login landing page and /closednotes briefly a tab of its own; the splat catches the retired
 * dashboards (overview, investor, tracking, ...) and a bare /pm-dashboard. Explicit routes
 * rather than a lookup on a `:subpath` param, so no URL segment is ever used as an object key.
 */
export const PM_DASHBOARD_REDIRECTS: { path: string; status?: DashboardNotesFilter }[] = [
  { path: "/pm-dashboard/activenotes", status: "active" },
  { path: "/pm-dashboard/closednotes", status: "closed" },
  { path: "/pm-dashboard/*" },
];
